import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    height: '20px',
    color:"#ffffff",
  },

  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});

const GREEN       = '#1a736a';
const GREEN_LIGHT = '#f0f7f5';
const DARK        = '#1a2e1d';
const GRAY        = '#555';

const STEPS = [
  {
    num: 1,
    title: 'Remove the liner and screen filter',
    body: 'Lift the liner out and set your orchid aside. Remove the screen filter from inside the pot.',
  },
  {
    num: 2,
    title: 'Rinse the inside of the pot',
    body: 'Run clean water through the pot and focus on the drainage holes and valve area. Swirl gently to loosen any fine bark particles. Repeat until the water runs clear.',
  },
  {
    num: 3,
    title: 'Rinse the screen filter',
    body: 'If the screen looks clogged with fine bark dust, rinse it separately under running water until water flows through freely.',
  },
  {
    num: 4,
    title: 'Reassemble — and you\'re done',
    body: 'Place the screen filter back inside, set the liner in, and return your orchid to its spot. Normal care resumes right away.',
  },
];

const SIGNS = [
  'The pot drains more slowly than usual',
  'The valve doesn\'t close all the way',
  'The bark doesn\'t soak evenly after filling',
];


class OrchimaCleanup extends Component {

  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    selectedUser:{},
    showOrderForm:false
  };

  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);

    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);

  }


  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    updateUserProfileAction(null, this.props.loginData.accessToken);
  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleShowOrderFormChange = event => {
    this.setState({ showOrderForm:!this.state.showOrderForm });
  };

  handleFirstNameChange(event) {
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
  }

  handleLastNameChange(event) {
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
  }

  handleEmailChange(event) {
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
  }

  handleCommentChange(event) {
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }

  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;

    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {
      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {
        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {
          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
            }
          }
        }
      }
    }

    return returnString;
  }

  handleAddress2Change(event) {
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }


  render() {
    return (
      <div style={{ backgroundColor: '#f9f9f7', minHeight: '100vh' }}>

        {/* Top nav */}
        <div style={{ backgroundColor: DARK, padding: '14px 24px' }}>
          <a href="/home" style={{ color: '#ffffff', textDecoration: 'none', fontSize: 14, fontWeight: 600, letterSpacing: 0.5 }}>
            ← Back to Orchima Home
          </a>
        </div>

        {/* Hero */}
        <div style={{ backgroundColor: GREEN, padding: '56px 24px', textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: '#a8d5cf', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12, marginTop: 0 }}>
            MAINTENANCE
          </p>
          <h1 style={{ fontSize: 'clamp(24px, 5vw, 34px)', fontWeight: 700, color: '#ffffff', lineHeight: 1.3, margin: '0 auto 16px auto', maxWidth: 600 }}>
            Keeping Your Orchima™ Clean
          </h1>
          <p style={{ fontSize: 17, color: '#d0ede9', maxWidth: 560, margin: '0 auto', lineHeight: 1.7 }}>
            This takes about two minutes and only needs to happen occasionally.
          </p>
        </div>

        {/* Content */}
        <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px' }}>

          {/* Why */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: 10, padding: '28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', marginBottom: 20 }}>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: DARK, marginBottom: 12, marginTop: 0 }}>
              Why You Might Need to Clean It
            </h2>
            <p style={{ fontSize: 16, color: GRAY, lineHeight: 1.8, margin: 0 }}>
              Over time, fine particles from orchid bark can settle inside the drainage holes or around the valve.
              When that happens, the valve may not close fully, or the pot may drain more slowly than usual.
            </p>
            <p style={{ fontSize: 16, color: GRAY, lineHeight: 1.8, marginTop: 12, marginBottom: 0 }}>
              A quick rinse is all it takes to clear the debris and get everything working properly again.
            </p>
          </div>

          {/* Signs */}
          <div style={{ backgroundColor: '#fff8f5', borderRadius: 10, padding: '20px 24px', marginBottom: 32, borderLeft: '4px solid #BF360C' }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: '#BF360C', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 10, marginTop: 0 }}>
              Signs it's time to clean
            </p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {SIGNS.map((sign, i) => (
                <li key={i} style={{ fontSize: 15, color: GRAY, lineHeight: 1.8 }}>{sign}</li>
              ))}
            </ul>
          </div>

          {/* Steps */}
          <h2 style={{ fontSize: 22, fontWeight: 700, color: DARK, marginBottom: 20 }}>How to Clean It</h2>

          {STEPS.map((step) => (
            <div key={step.num} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 24 }}>
              <div style={{
                minWidth: 44, height: 44, borderRadius: '50%',
                backgroundColor: GREEN, color: '#ffffff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 700, fontSize: 18, marginRight: 20, flexShrink: 0,
              }}>
                {step.num}
              </div>
              <div style={{ paddingTop: 6 }}>
                <p style={{ fontSize: 17, fontWeight: 700, color: DARK, marginBottom: 6, marginTop: 0 }}>{step.title}</p>
                <p style={{ fontSize: 15, color: GRAY, lineHeight: 1.8, margin: 0 }}>{step.body}</p>
              </div>
            </div>
          ))}

          {/* How often */}
          <div style={{ backgroundColor: GREEN_LIGHT, borderRadius: 10, padding: '24px 28px', marginBottom: 48 }}>
            <p style={{ fontSize: 16, fontWeight: 700, color: GREEN, marginBottom: 8, marginTop: 0 }}>How often?</p>
            <p style={{ fontSize: 15, color: GRAY, lineHeight: 1.8, margin: 0 }}>
              Most users clean their Orchima™ once every few months, or whenever they notice drainage slowing down.
              Coarser bark breaks down more slowly, so you may need to clean it even less frequently.
            </p>
          </div>

          <div style={{ textAlign: 'center', paddingBottom: 24 }}>
            <a href="/home" style={{ color: GREEN, fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>
              ← Back to Orchima Home
            </a>
          </div>

        </div>
      </div>
    );
  }
}

OrchimaCleanup.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchimaCleanup));
